const DB_NAME = 'kyiv-date';
const STORE_NAME = 'pending-video';
const KEY = 'current';

interface PendingVideoEntry {
  hid: string;
  file: File;
}

const openDB = (): Promise<IDBDatabase> =>
  new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1);
    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(new Error(String(request.error)));
  });

export const savePendingVideo = async (
  hid: string,
  file: File
): Promise<void> => {
  try {
    const db = await openDB();
    const tx = db.transaction(STORE_NAME, 'readwrite');
    tx.objectStore(STORE_NAME).put({ hid, file } as PendingVideoEntry, KEY);
    await new Promise<void>((resolve, reject) => {
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(new Error(String(tx.error)));
    });
  } catch {
    // ignore
  }
};

export const readPendingVideo = async (): Promise<{
  hid: string;
  url: string;
} | null> => {
  try {
    const db = await openDB();
    const tx = db.transaction(STORE_NAME, 'readonly');
    const request = tx.objectStore(STORE_NAME).get(KEY);
    const entry = await new Promise<PendingVideoEntry | undefined>(
      (resolve, reject) => {
        request.onsuccess = () =>
          resolve(request.result as PendingVideoEntry | undefined);
        request.onerror = () => reject(new Error(String(request.error)));
      }
    );
    if (!entry?.hid || !entry?.file) return null;
    const url = URL.createObjectURL(entry.file);
    return { hid: entry.hid, url };
  } catch {
    return null;
  }
};

export const removePendingVideo = async (): Promise<void> => {
  try {
    const db = await openDB();
    const tx = db.transaction(STORE_NAME, 'readwrite');
    tx.objectStore(STORE_NAME).delete(KEY);
    await new Promise<void>((resolve, reject) => {
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(new Error(String(tx.error)));
    });
  } catch {
    // ignore
  }
};
